import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SubscriptionFeeUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(requestData) {
        return await this.repo.getSubscriptionFee(requestData);
    }
}
export default SubscriptionFeeUseCase;
